/* eslint no-param-reassign: "error" */
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  Button,
  AddGroup,
  UploadPhoto,
} from 'web-components';

import {
  getUiState,
} from 'web-selectors';

import {
  uiActions,
} from 'web-actions';

import {
  coreActions,
} from '@gymcloud/core';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';

type Props = {
  groupInfo: any,
};

const mapState = (state => ({
  ...getUiState([
    'fileUpload',
    'addGroupModal',
  ])(state),
}));

const Header = ({ groupInfo }: Props) => {
  const dispatch = useDispatch();

  const {
    fileUpload,
    addGroupModal,
  } = useSelector(mapState, shallowEqual);

  const onRequestEdit = () => {
    dispatch(uiActions.setUiState({ addGroupModal: true }));
  };

  return (
    <Flex
      column
      width="100%"
      spacing={10}
    >
      <S.GroupInfo>
        <Flex
          spacing={20}
          padding="20px 0 0 20px"
        >
          <UploadPhoto
            width={140}
            height={140}
            src={groupInfo?.avatar?.large?.url}
            uploadProgress={fileUpload[groupInfo.id]?.progress || 0}
            onChange={(file) => {
              dispatch(
                coreActions.requestUploadGroupAvatar({
                  file,
                  groupId: groupInfo.id,
                }),
              );
            }}
          />
          <Flex
            justify="center"
            spacing={15}
            padding="0 0 0 10px"
            column
          >
            <Text
              size="20px"
              color="#fff"
              weight={800}
            >
              {groupInfo?.name}
            </Text>
            <S.GroupLink
              placeholder={window.location.href}
              readOnly
            />
            <Button
              ghost
              appearance="primaryReverse"
              spacing="large"
              alignSelf="center"
              onClick={onRequestEdit}
            >
              Edit
            </Button>
          </Flex>
        </Flex>
      </S.GroupInfo>
      <AddGroup
        isOpen={addGroupModal}
        groupName={`${groupInfo?.name}`}
        groupAvatar={groupInfo?.avatar?.large?.url}
        headerText={`Edit group ${groupInfo?.name}`}
        onRequestClose={() => {
          dispatch(
            uiActions.setUiState({
              addGroupModal: false,
            }),
          );
        }}
        onSubmit={(
          values,
          actions,
          file,
        ) => {
          if (file) {
            dispatch(
              coreActions.requestUploadGroupAvatar({
                file,
                groupId: groupInfo.id,
              }),
            );
          }

          dispatch(
            coreActions.requestUpdateEntity({
              id: groupInfo.id,
              payload: values,
              endNotify: true,
              resourceType: 'clientGroups',
              callbacks: {
                ...actions,
                onSuccess: () => {
                  dispatch(
                    uiActions.setUiState({
                      addGroupModal: false,
                    }),
                  );
                },
              },
            }),
          );
        }}
      />
    </Flex>
  );
};

export default Header;
